import { render, staticRenderFns } from "./ApplicationSubmission.vue?vue&type=template&id=22c0f756&scoped=true&"
import script from "./ApplicationSubmission.vue?vue&type=script&lang=js&"
export * from "./ApplicationSubmission.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSubmission.vue?vue&type=style&index=0&id=22c0f756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0f756",
  null
  
)

export default component.exports